<template>
    <div id="app" :class="{ container: isShowContainer }">
        <div class="app-loading" v-if="$store.state.loading.loading">
            <van-loading type="spinner" color="#1989fa"/>
        </div>
        <router-view/>
        <TabBar v-if="$route.meta.showTabBar"></TabBar>
    </div>
</template>

<script>
import TabBar from '@/components/tabBar/tabBar.vue'
import {checkIsPc} from "@/commonJS/common";

export default {
    data () {
        return {
            isShowContainer: false,
        }
    },
    async mounted () {
        if (checkIsPc()) {
            require('@/assets/css/pc.scss')
            this.isShowContainer = true
        } else {
            this.isShowContainer = false
            require('@/assets/css/mobile.scss')
        }
        window.addEventListener('resize', () => {
            setTimeout(() => {
                if (checkIsPc()) {
                    require('@/assets/css/pc.scss')
                    this.isShowContainer = true
                } else {
                    require('@/assets/css/mobile.scss')
                    this.isShowContainer = false
                }
            }, 50)

        })
    },
    components: {
        TabBar,
    },
}
</script>

<style lang="scss">
@import "./assets/css/public.scss";

.app-loading {
    position: fixed;
    z-index: 9999;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
